var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floor-style-2 floor-style-4"},[(_vm.data.value.bottomImg.value.url)?_c('div',{staticClass:"bottom-wrap"},[_c('img',{attrs:{"src":_vm.$img(_vm.data.value.bottomImg.value.url)},on:{"click":function($event){return _vm.$router.pushToTab(_vm.data.value.bottomImg.value.link.url)}}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }